export class GetProjectConfigurationKeysResponse {
    'ENVIRONMENT_CLASSIFICATION_PATTERNS';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ENVIRONMENT_CLASSIFICATION_PATTERNS",
            "baseName": "ENVIRONMENT_CLASSIFICATION_PATTERNS",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetProjectConfigurationKeysResponse.attributeTypeMap;
    }
    constructor() {
    }
}
